export default "__VITE_ASSET__Cg4Ui4Wf__"